import { CSSProperties } from "react";

export interface Styles {
  card: CSSProperties;
  pageTitle: CSSProperties;
  description: CSSProperties;
}

const styles: Styles = {
  card: {
    border: "1px solid #eef0f4",
  },
  pageTitle: {
    fontFamily: "var(--primary-font-semibold)",
    fontSize: 18,
    color: "#1A1B22",
  },
  description: {
    maxWidth: 440,
    fontSize: 13,
    lineHeight: "20px",
    color: "#4b5563",
  },
};

export default styles;
